(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'GoldCardDestinations',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.onload('/GoldCardDestinations/add', function onload()
		{
			Adzuki.Form.registerForm(form);
		});
	});

	form.load = function load($form)
	{
		$('#goldcarddestinations-cruise_line').change(function vendorChanged()
		{
			changePromotionList('#goldcarddestinations-cruise_line');
		});

		$('#goldcarddestinations-vendor').change(function vendorChanged()
		{
			changePromotionList('#goldcarddestinations-vendor');
		});

		$('#goldcarddestinations-vendor_confirmation').keyup(function vendorConfirmationChanged()
		{
			var $self = $(this),
			    value = $self.val();

			$self.val(value.toUpperCase());
		});

		$('#reset_gcd_form').click(function resetFormClicked(event)
		{
			var $self   = $(this),
			    $form   = $self.closest('form'),
			    $fields = $form.find('input[type="text"],input[type="hidden"],select');

			event.preventDefault();

			$.each($fields, function fieldsForeach(key, item)
			{
				$(item).val('');
				if (typeof $(item).data('DateTimePicker') === 'object') {
					$(item)
						.data('DateTimePicker')
						.date(null);
				}
			});

			$('#goldcarddestinations-cruise_line').trigger('click');
			$('input[name="form_component_data[GoldCardDestinations][Reservation Search]"]').data('adzuki').reset();
		});

		$('#goldcarddestinations-booking_type-0,#goldcarddestinations-booking_type-1').change(function bookingTypeChanged()
		{
			var booking_type        = $(this).val(),
			    $promotionCodeField = $('#goldcarddestinations-promotion_code');

			$promotionCodeField.empty();
			$promotionCodeField.append($('<option>').text('Select the Promotion Code').attr('value', ''));

			if (booking_type === 'cruise') {
				changePromotionList('#goldcarddestinations-cruise_line');
				$('.cruise-container').removeClass('hidden');
				$('.tour-container').addClass('hidden');
			} else {
				changePromotionList('#goldcarddestinations-vendor');
				$('.tour-container').removeClass('hidden');
				$('.cruise-container').addClass('hidden');
			}
		});

		$('input[name="form_component_data[GoldCardDestinations][Reservation Search]"]').on('ta.set-hidden', function existingReservationChanged(event)
		{
			var $self                  = $(this),
			    $modal                 = $('.modal'),
			    reservationId          = $('#goldcarddestinations-existing_reservation_id').val(),
			    reservationFields      = $('input.reservation-field,select.reservation-field'),
			    reservationTypeToggles = $('div.reservation-field').find('label.btn-radio'),
			    confirmationNumber;

			if ($self.prop('disabled') === true && $.trim(reservationId)) {

				confirmationNumber = $self.val().replace(/^.*\ \-\ (.+)\ on\ .*$/, '$1');

				// Get reservation info to determine promotion code. Possibly populate other info in disabled fields
				// so user is aware it is successful.
				Adzuki.Ajax.get('/GoldCardDestinations/getComponentTypeFromReservation/' + reservationId + '/' + confirmationNumber)
					.then(function getComponentSuccess(response)
					{
						if (response.status === true && typeof response.error === 'undefined') {
							// disable other fields related to booking, program info withstanding
							reservationFields.attr('disabled', true);

							populateExistingComponentFields(response.component);

							reservationTypeToggles.addClass('disabled');
						} else if (typeof response.error === 'string' && $.trim(response.error)) {
							Adzuki.StatusMessage('error', response.error);
						} else if (response.status === false) {
							Adzuki.StatusMessage('error', 'Unable to select reservation');
						} else {
							$modal.find('.modal-body').html(response);
							$modal.find('[data-toggle^="tooltip"]').tooltip();
							$modal.find('[data-toggle^="collapse"]').collapse();

							$modal.find('.modal-title').html('Request New Code - Select a Component');

							$modal.on('click', '.btn.btn-default', function _clearSearch() {
								$('input[name="form_component_data[GoldCardDestinations][Reservation Search]"]').data('adzuki')
									.reset();
								$modal.find('.btn.btn-default').off('click');
							}).modal('show');

							$('.gcd-select-existing-component').click(function selectExistingComponentOnClick()
							{
								var $self         = $(this),
								    componentId   = $self.data('id'),
								    componentType = $self.data('type');

								Adzuki.Ajax.get('/GoldCardDestinations/getExistingReservationComponent/' + componentId + '/' + componentType)
									.then(function getExistingComponentSuccess(response)
									{
										if (response.status === true) {
											reservationFields.attr('disabled', true);
											populateExistingComponentFields(response.component);

											$modal.modal('hide');
											reservationTypeToggles.addClass('disabled');
										} else {
											Adzuki.StatusMessage('error', 'Unable to select component');
										}
									});
							});
						}
					});
			} else {
				// reenable said fields
				reservationFields.attr('disabled', false);
				reservationTypeToggles.removeClass('disabled');
			}

		});

		$('input[name="form_component_data[GoldCardDestinations][Reservation Search]"]').on('ta.reset', function existingReservationRemoved()
		{
			var reservationFields      = $('input.reservation-field,select.reservation-field'),
			    reservationDateFields  = $('input.reservation-field.adzuki-datetimepicker'),
			    reservationTypeToggles = $('div.reservation-field').find('label.btn-radio');

			reservationFields.attr('disabled', false);
			reservationFields.val('');

			if (typeof reservationDateFields.data('DateTimePicker') === 'object') {
				reservationDateFields
					.data('DateTimePicker')
					.date(null);
			}

			reservationTypeToggles.removeClass('disabled');
		});

		$('#goldcarddestinations-cruise_line').change(function resultsCruiseLineChanged() {
			var cruiseLineId                  = $(this).val(),
			    $shipField                    = $('#goldcarddestinations-ship'),
			    $shipExistingReservationField = $('#goldcarddestinations-existing_reservation_ship_id');

			$shipField.empty();
			$shipField.append($('<option>').text('Select the Cruise Ship').attr('value', ''));

			if ($.trim(cruiseLineId)) {
				Adzuki.Ajax.get('/CruiseSearch/getShips/' + cruiseLineId)
				.then(function getShipsSuccess(data) {
					var sortedData = Adzuki.Sort.alphabeticValue(data);

					$.each(sortedData, function parseShips(key, ship) {
						var $option = $('<option>').text(ship['value']).attr('value', ship['key']);

						if (
							$.trim($shipField.data('reservation-ship'))
							&& ship['value'] === $shipField.data('reservation-ship')
						) {
							$option.attr('selected', true);
							$shipField.val(ship['key']);
							$shipExistingReservationField.val(ship['key']);
						}

						$shipField.append($option);
					});
				});
			}
		});

		$('#goldcarddestinations-departure_date').on('dp.change', function departureDateChanged(event)
		{
			var departDate = (event.date ? event.date : null);

			$('#goldcarddestinations-return_date')
				.data('DateTimePicker')
				.date(departDate);
		});
	};

	form.confirmation = function confirmation(response)
	{
		Adzuki.CustomConfirm({
			body   : response.data.message,
			confirm: function agentConfirmedClientChange() {
				$('#goldcarddestinations-confirmed').val(1);
				$(form.element).submit();
			},
		});
	};

	function changePromotionList(selector)
	{
		var type                = $(selector).prop('id').replace('goldcarddestinations-', ''),
		    vendor              = $(selector).val(),
		    $promotionCodeField = $('#goldcarddestinations-promotion_code');

		if ($.trim(type) === 'cruise_line') {
			type = 'cruise';
		} else {
			type = 'tour';
		}

		$promotionCodeField.empty();
		$promotionCodeField.append($('<option>').text('Select the Promotion Code').attr('value', ''));

		if ($.trim(vendor)) {
			Adzuki.Ajax.get('/GoldCardDestinations/getPromoCodesByType/' + vendor + '/' + type)
			.then(function getPromoCodesByTypeSuccess(data)
			{
				if (data.status === true) {
					$.each(data.promotionCodes, function parsePromotionCodes(key, code)
					{
						$promotionCodeField.append($('<option>').text(code).attr('value', key));
					});
				}
			});
		}
	}

	function populateExistingComponentFields(component)
	{
		$('#goldcarddestinations-existing_reservation_component_id').val(component.id);
		$('#goldcarddestinations-departure_date').data('DateTimePicker')
			.date(component.departureDate);
		$('#goldcarddestinations-return_date').data('DateTimePicker')
			.date(component.returnDate);
		$('#goldcarddestinations-vendor_confirmation').val(component.confirmationNumber);
		$('#goldcarddestinations-total_price').val(component.totalPrice);

		if (component.clientFirst && component.clientLast) {
			$('#goldcarddestinations-card_member_first').val(component.clientFirst);
			$('#goldcarddestinations-card_member_last').val(component.clientLast);
		}

		if ($('#goldcarddestinations-booking_type-0').val() === component.type) {
			$('#goldcarddestinations-booking_type-0').trigger('click');

			$('#goldcarddestinations-cruise_line option').each(function eachCruiseLine(key, item)
			{
				if ($(item).text() === component.vendor) {
					$('#goldcarddestinations-cruise_line option').attr('selected', false);
					$(item).attr('selected', true);
					$('#goldcarddestinations-existing_reservation_cruise_line_id').val($(item).val());
					$('#goldcarddestinations-cruise_line').val($(item).val());
				}
			});

			$('#goldcarddestinations-ship').data('reservation-ship', component.ship);
			$('#goldcarddestinations-cruise_line').trigger('change');

		} else if ($('#goldcarddestinations-booking_type-1').val() === component.type) {
			$('#goldcarddestinations-booking_type-1').trigger('click');

			$('#goldcarddestinations-vendor option').each(function eachTourCompany(key, item)
			{
				if ($(item).text() === component.vendor) {
					$('#goldcarddestinations-vendor option').attr('selected', false);
					$(item).attr('selected', true);
					$('#goldcarddestinations-existing_reservation_vendor_id').val($(item).val());
					$('#goldcarddestinations-vendor').val($(item).val());
				}
			});

			$('#goldcarddestinations-vendor').trigger('change');
		}
	}
}(jQuery, window.Adzuki || {}));
